<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="text-h6">
                <v-icon left color="primary">mdi-account-key</v-icon>
                Account utente collegato
                <v-spacer></v-spacer>
                <v-btn icon @click="load" :loading="loading">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text v-if="!loading">
                <div v-if="employee && employee.user">
                    <v-row dense>
                        <v-col cols="12" md="6">
                            <div class="text-caption">Nome utente</div>
                            <div class="text-body-1 font-weight-bold">{{ employee.user.name }}</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="text-caption">Email</div>
                            <div class="text-body-1 font-weight-bold">{{ employee.user.email }}</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="text-caption">Ruolo</div>
                            <div class="text-body-1">{{ employee.user.role_name || '—' }}</div>
                        </v-col>
                        <v-col cols="12" md="6">
                            <div class="text-caption">User ID</div>
                            <div class="text-body-1">#{{ employee.user.id }}</div>
                        </v-col>
                    </v-row>
                    <v-alert type="info" dense text class="mt-3">
                        L'utente <strong>{{ employee.user.name }}</strong> e' collegato a questo dipendente.
                        Le sue richieste assenza, timbrature e note spese verranno automaticamente associate.
                    </v-alert>
                    <v-btn small color="error" outlined class="mt-2" @click="confirmUnlink">
                        <v-icon left small>mdi-link-off</v-icon>
                        Scollega utente
                    </v-btn>
                </div>

                <div v-else>
                    <v-alert type="warning" dense text>
                        Nessun account utente collegato. Il dipendente non potra' accedere all'app per timbrare,
                        richiedere ferie o registrare note spese personali.
                    </v-alert>
                    <v-autocomplete
                        v-model="selectedUserId"
                        :items="availableUsers"
                        :loading="usersLoading"
                        item-text="text"
                        item-value="value"
                        label="Seleziona utente da collegare"
                        prepend-icon="mdi-account-search"
                        outlined
                        dense
                        hide-details
                        clearable
                        :search-input.sync="userSearch"
                    ></v-autocomplete>
                    <v-btn color="primary" small class="mt-3" :disabled="!selectedUserId" :loading="saving" @click="link">
                        <v-icon left small>mdi-link</v-icon>
                        Collega utente
                    </v-btn>
                </div>
            </v-card-text>
        </v-card>

        <v-dialog v-model="unlinkDialog" max-width="400">
            <v-card>
                <v-card-title>Conferma scollegamento</v-card-title>
                <v-card-text>
                    L'utente sara' scollegato dal dipendente. Le entita' gia' associate (timbrature, assenze, ecc.) restano.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="unlinkDialog = false">Annulla</v-btn>
                    <v-btn color="error" :loading="saving" @click="unlink">Scollega</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    export default {
        name: 'hr-employee-account',
        props: { id: Number },

        data() {
            return {
                employee: null,
                loading: false,
                saving: false,
                usersLoading: false,
                availableUsers: [],
                selectedUserId: null,
                userSearch: '',
                unlinkDialog: false,
            }
        },

        watch: {
            userSearch(v) {
                if (v && v.length >= 2) this.searchUsers(v)
            },
        },

        methods: {
            load() {
                this.loading = true
                this.axios.get(`hremployees/${this.id}?lite=1`).then(r => {
                    this.employee = r.data.model
                    this.loading = false
                    if (!this.employee.user) this.searchUsers('')
                }, () => { this.loading = false })
            },
            searchUsers(q) {
                this.usersLoading = true
                this.axios.post('users-filters', { filter: q || '', per_page: 30 }).then(r => {
                    const data = r.data.data && r.data.data.data ? r.data.data.data : (Array.isArray(r.data.data) ? r.data.data : [])
                    this.availableUsers = data.map(u => ({
                        value: u.id,
                        text: `${u.name || ''} (${u.email || '#' + u.id})`,
                    }))
                    this.usersLoading = false
                }, () => { this.usersLoading = false })
            },
            link() {
                this.saving = true
                this.axios.post(`hremployees/${this.id}/link-user`, { user_id: this.selectedUserId }).then(() => {
                    this.saving = false
                    this.selectedUserId = null
                    this.load()
                }, () => { this.saving = false })
            },
            confirmUnlink() {
                this.unlinkDialog = true
            },
            unlink() {
                this.saving = true
                this.axios.post(`hremployees/${this.id}/link-user`, { user_id: null }).then(() => {
                    this.saving = false
                    this.unlinkDialog = false
                    this.load()
                }, () => { this.saving = false })
            },
        },

        created() {
            this.$store.commit('endProgress')
            this.load()
        },
    }
</script>
